const STATUS_CONFIG = {
  DRAFT: { label: "Draft (admin only)", icon: "\u270E", className: "status-badge--draft" },
  PLANNED: { label: "Planned \u2013 tentative", icon: "\u23F3", className: "status-badge--planned" },
  CONFIRMED: { label: "Confirmed \u2013 RSVP open", icon: "\u2705", className: "status-badge--confirmed" },
  FULL: { label: "Full \u2013 waitlist open", icon: "\u26A0\uFE0F", className: "status-badge--full" },
  CANCELED: { label: "Canceled", icon: "\u2716", className: "status-badge--canceled" },
  COMPLETED: { label: "Completed", icon: "\u2713", className: "status-badge--completed" },
  PENDING_VERIFICATION: { label: "Pending verification", icon: "\u2709", className: "status-badge--planned" },
  WAITLISTED: { label: "Waitlisted", icon: "\u26A0\uFE0F", className: "status-badge--full" },
  EXPIRED: { label: "Expired", icon: "\u2716", className: "status-badge--draft" },
};

/**
 * Renders an event status badge. Always pairs an icon + text label so
 * meaning does not depend on color alone (WCAG 1.4.1).
 */
export default function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || { label: status, icon: "", className: "status-badge--draft" };
  return (
    <span className={`status-badge ${config.className}`}>
      <span className="status-icon" aria-hidden="true">
        {config.icon}
      </span>
      {config.label}
    </span>
  );
}

export function statusDescription(status) {
  switch (status) {
    case "PLANNED":
      return "Tentative \u2014 library room not yet confirmed. RSVP will open after the room is reserved.";
    case "CONFIRMED":
      return "RSVPs are open for this event.";
    case "FULL":
      return "This event is full, but you can join the waitlist.";
    case "CANCELED":
      return "This event has been canceled.";
    case "COMPLETED":
      return "This event has already taken place.";
    default:
      return "";
  }
}
